function getRegBanner() {
    var result = "";
    if (global.$registrationform.regbanner != null) {
        result = global.$registrationform.regbanner
    }
    return result;
}

export default { getRegBanner }